import { useContext, useState } from "react"
import { AuthenticationContext } from "../../../AuthenticationContext"
import VSpace from "../../common/VSpace"
import { Alert, Space, Typography } from "antd"
import LabeledSwitch from "../../common/LabeledSwitch"
import { useStartMerchantApplicationMutation } from "../../../domain/invoicing/rainforestQueries"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock } from "@fortawesome/pro-solid-svg-icons"
import ThemableButton from "../../Items/ThemableButton"

const MerchantApplicationWelcome = () => {
  const { currentUser } = useContext(AuthenticationContext)
  const [useSandbox, setUseSandbox] = useState(false)
  const isSuperUser = currentUser?.isSuperUser === true
  const startMerchantApplicationMutation = useStartMerchantApplicationMutation()

  return <VSpace size="large">
    <img src="/images/synkedup-light.png" style={{ height: '64px' }}></img>
    <div style={{ fontSize: 24, fontWeight: 600 }}>Setup SynkedUP Payments</div>
    <Typography.Text type="secondary">
      Start your SynkedUP Payments application to manage invoices and payments directly in SynkedUP.
    </Typography.Text>
    <Space>
      <Typography.Text type="secondary">
        <Space>
          <FontAwesomeIcon icon={faClock} />
          <span>Approximate completion time &ndash;</span>
        </Space>
      </Typography.Text>
      <strong>Less than 10:00 minutes</strong>
    </Space>
    <div>
      <strong>What to expect during setup:</strong>
      <ul style={{ paddingLeft: '16px' }}>
          <li style={listItemStyle}>Provide your business details</li>
          <li style={listItemStyle}>Share information about your business owners</li>
          <li style={listItemStyle}>Add your bank account for deposits</li>
      </ul>
    </div>
    <Typography.Text type="secondary">
      Once you submit your application, our team will review it. If we need more information, we'll reach out. After approval, you'll be ready to accept customer payments.
    </Typography.Text>
    <Alert type="warning" showIcon message="The application review process can take up to 3 business days." />
    <div>
      <i>Note: SynkedUP Payments is currently only available in U.S. dollars.</i>
    </div>
    {isSuperUser && <Alert type="warning" description={<VSpace>
      <strong>Super User Option:</strong>
        <LabeledSwitch
          value={useSandbox}
          onChange={setUseSandbox}
          label="Use sandbox"
        />
      </VSpace>
    } />}
    <ThemableButton type="primary"
      loading={startMerchantApplicationMutation.isLoading}
      onClick={() => startMerchantApplicationMutation.mutate(useSandbox)}
      disabled={startMerchantApplicationMutation.isLoading}
      style={{ width: '100%' }}
      size="large"
      colorPrimary="#FF5C35"
    >Get Started</ThemableButton>
  </VSpace>
}

export default MerchantApplicationWelcome

const listItemStyle = {
  marginTop: '8px'
}